import { render, staticRenderFns } from "./ChatUnsubscirbed.vue?vue&type=template&id=8744acac&scoped=true&"
import script from "./ChatUnsubscirbed.vue?vue&type=script&lang=js&"
export * from "./ChatUnsubscirbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8744acac",
  null
  
)

export default component.exports